module.exports = __webpack_public_path__ + "static/media/linked-in.b243c802.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/linked-in.svg
// module id = 1097
// module chunks = 0